'use client'

import { useSession } from 'next-auth/react'

import { useQuery } from '@tanstack/react-query'

import { fetchInitialUserDataClient } from '@/shared/lib/data/fetchInitialUserDataClient'

const INITIAL_USER_DATA_QUERY_KEY = ['initial-user-data'] as const

export function useInitialUserData() {
  const { data: session, status } = useSession()
  const accessToken = session?.accessToken

  return useQuery({
    queryKey: INITIAL_USER_DATA_QUERY_KEY,
    queryFn: fetchInitialUserDataClient,
    enabled: status === 'authenticated' && !!accessToken,
    staleTime: 1000 * 60 * 5,
    retry: 2
  })
}
